<template>
  <div class="lossCustomer">
    <div class="tab_component_wrap">
      <div class="customer_list_wrap">
        <van-list
            v-model="loading"
            :finished="finished"
            loading-text="正在加载中..."
            finished-text="暂无更多内容了"
            :immediate-check="false"
            @load="load_more"
        >
          <div class="customer_item" v-for="item in list" :key="item.id">
            <div class="customer_item_left">
              <p>{{item.name}}</p>
              <span>流失时间：{{item.lostTime.split(' ')[0]}}</span>
            </div>
            <div class="customer_item_right">
                <span>添加时间：{{item.firstAddTime.split(' ')[0]}}</span>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { lossReminder } from '@/server/api';
import {Toast} from 'vant';
export default {
  name: "lossCustomer",
  data(){
    return {
      loading:false,
      finished:false,
      pageNum:1,
      pageSize:25,
      userIds:['HuangLiJie'],
      list:[],
    }
  },
  created() {
    this.getCustomerList();
  },
  methods:{

    load_more(){
      this.pageNum++;
      this.getCustomerList();
    },
    async getCustomerList(){
      this.loading = true;
      const res = await lossReminder({
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        userId:'HuangLiJie'
      });
      this.loading = false;
      if (res.code !== "200") return Toast.fail(res.msg);
      this.list = this.list.concat(res.data.list);
      if (res.data.list.length == 0 || res.data.list.length < this.pageSize) {
        //数据全部加载完成
        this.finished = true;
      } else {
        this.finished = false;
      }
    },

  },
}
</script>

<style scoped lang="less">
.lossCustomer{
  .tab_component_wrap{
    padding: 0 30px;
    .header_title{
      font-size: 24px;
      color: #999999;
    }
    .customer_list_wrap{
      padding-top: 14px;
      .customer_item{
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 16px;
        background-color: #ffffff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .customer_item_left{
          p{
            font-size: 28px;
            color: #333333;
            margin-bottom: 10px;
          }
          span{
            font-size: 24px;
            color: #666666;
          }
        }
        .customer_item_right{
          display: flex;
          align-items:end;
          span{
            color: #666666;
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>
